import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import React from "react";

import { UnitTableCategoryFilter } from '@/components/controls/filter/unitTableCategoryFilter';
import { UnitTableFeatureFilter } from '@/components/controls/filter/unitTableFeatureFilter';
import type { UnitFeature, UnitCategory } from "@/types";
import { Button } from "@/components/ui/button";

interface UnitTableFiltersProps {
    features: UnitFeature[];
    selectedFeatures: number[];
    setSelectedFeatures: React.Dispatch<React.SetStateAction<number[]>>;
    categories: UnitCategory[];
    selectedCategories: number[];
    setSelectedCategories: React.Dispatch<React.SetStateAction<number[]>>;
}

export const UnitTableFilters: React.FC<UnitTableFiltersProps> = ({features, selectedFeatures, setSelectedFeatures, categories, selectedCategories, setSelectedCategories}) => {
    return (
        <Popover>
            <PopoverTrigger asChild><Button variant={"outline"}>Filters</Button></PopoverTrigger>
            <PopoverContent className="se-vapor se-vapor-filters">
                <UnitTableFeatureFilter
                    features={features}
                    selectedFeatures={selectedFeatures}
                    setSelectedFeatures={setSelectedFeatures}
                />
                <UnitTableCategoryFilter
                    categories={categories}
                    selectedCategories={selectedCategories}
                    setSelectedCategories={setSelectedCategories}
                />
            </PopoverContent>
        </Popover>
    );
};
